import { SxStyle } from '@aibees/shared/theme';

export const title: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: (p) => p.spacing(2),
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  borderBottomColor: (p) => p.palette.grey[300],
};

export const stack: SxStyle = {
  padding: (p) => p.spacing(2),
};

export const divider: SxStyle = {
  margin: (p) => p.spacing(1.5, 0),
  width: (p) => `calc(100% + ${p.spacing(5)})`,
  marginLeft: (p) => `-${p.spacing(3)}`,
};
